const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: '最小值與最大值輸入無效。',
    invalid_options: '欄位選項無效。',
    invalid_regex_format: '正則表達式格式無效。',
    invalid_address_parts: '地址組成部分無效。',
    invalid_fullname_parts: '全名組成部分無效。',
    name_exists: '已存在具有該名稱的欄位。',
    conflicted_sie_order: '登入體驗的欄位順序值衝突。',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
